/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarTagDePacienteDto,
  CriarTagDePacienteDto,
  ErroResponse,
  PaginaDeTagsDePacienteResponse,
  TagDePacienteResponse,
  TagsDePacienteControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTagsDePacienteControllerListarUrl = (params?: TagsDePacienteControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tags-de-paciente?${stringifiedParams}` : `/v1/tags-de-paciente`
}

/**
 * @summary Lista as tags de paciente do ambiente.
 */
export const tagsDePacienteControllerListar = async (params?: TagsDePacienteControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeTagsDePacienteResponse> => {

  return httpClient<PaginaDeTagsDePacienteResponse>(getTagsDePacienteControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTagsDePacienteControllerListarQueryKey = (params?: TagsDePacienteControllerListarParams,) => {
    return [
    `/v1/tags-de-paciente`, ...(params ? [params] : [])
    ] as const;
    }


export const getTagsDePacienteControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError = unknown>(params?: TagsDePacienteControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagsDePacienteControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>> = ({ signal }) => tagsDePacienteControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagsDePacienteControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>>
export type TagsDePacienteControllerListarQueryError = unknown


export function useTagsDePacienteControllerListar<TData = Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError = unknown>(
 params: undefined |  TagsDePacienteControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagsDePacienteControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tagsDePacienteControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagsDePacienteControllerListar<TData = Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError = unknown>(
 params?: TagsDePacienteControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagsDePacienteControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tagsDePacienteControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagsDePacienteControllerListar<TData = Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError = unknown>(
 params?: TagsDePacienteControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as tags de paciente do ambiente.
 */

export function useTagsDePacienteControllerListar<TData = Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError = unknown>(
 params?: TagsDePacienteControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagsDePacienteControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagsDePacienteControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTagsDePacienteControllerCriarUrl = () => {




  return `/v1/tags-de-paciente`
}

/**
 * @summary Cria uma tag de paciente.
 */
export const tagsDePacienteControllerCriar = async (criarTagDePacienteDto: CriarTagDePacienteDto, options?: Parameters<typeof httpClient>[1]): Promise<TagDePacienteResponse> => {

  return httpClient<TagDePacienteResponse>(getTagsDePacienteControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarTagDePacienteDto)
  }
);}





export const getTagsDePacienteControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>, TError,{data: CriarTagDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>, TError,{data: CriarTagDePacienteDto}, TContext> => {

const mutationKey = ['tagsDePacienteControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>, {data: CriarTagDePacienteDto}> = (props) => {
          const {data} = props ?? {};

          return  tagsDePacienteControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagsDePacienteControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>>
    export type TagsDePacienteControllerCriarMutationBody = CriarTagDePacienteDto
    export type TagsDePacienteControllerCriarMutationError = unknown

    /**
 * @summary Cria uma tag de paciente.
 */
export const useTagsDePacienteControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>, TError,{data: CriarTagDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagsDePacienteControllerCriar>>,
        TError,
        {data: CriarTagDePacienteDto},
        TContext
      > => {
      return useMutation(getTagsDePacienteControllerCriarMutationOptions(options), queryClient);
    }
    export const getTagsDePacienteControllerAtualizarUrl = (id: string,) => {




  return `/v1/tags-de-paciente/${id}`
}

/**
 * @summary Edita nome e/ou cor. Campo omitido fica como está.
 */
export const tagsDePacienteControllerAtualizar = async (id: string,
    atualizarTagDePacienteDto: AtualizarTagDePacienteDto, options?: Parameters<typeof httpClient>[1]): Promise<TagDePacienteResponse> => {

  return httpClient<TagDePacienteResponse>(getTagsDePacienteControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarTagDePacienteDto)
  }
);}





export const getTagsDePacienteControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>, TError,{id: string;data: AtualizarTagDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>, TError,{id: string;data: AtualizarTagDePacienteDto}, TContext> => {

const mutationKey = ['tagsDePacienteControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>, {id: string;data: AtualizarTagDePacienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tagsDePacienteControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagsDePacienteControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>>
    export type TagsDePacienteControllerAtualizarMutationBody = AtualizarTagDePacienteDto
    export type TagsDePacienteControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita nome e/ou cor. Campo omitido fica como está.
 */
export const useTagsDePacienteControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>, TError,{id: string;data: AtualizarTagDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagsDePacienteControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarTagDePacienteDto},
        TContext
      > => {
      return useMutation(getTagsDePacienteControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getTagsDePacienteControllerExcluirUrl = (id: string,) => {




  return `/v1/tags-de-paciente/${id}`
}

/**
 * @summary Exclui a tag (lógica). Os pacientes não são tocados.
 */
export const tagsDePacienteControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getTagsDePacienteControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTagsDePacienteControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['tagsDePacienteControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tagsDePacienteControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagsDePacienteControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>>

    export type TagsDePacienteControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclui a tag (lógica). Os pacientes não são tocados.
 */
export const useTagsDePacienteControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagsDePacienteControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTagsDePacienteControllerExcluirMutationOptions(options), queryClient);
    }
